import { computed, ref } from 'vue';
import VersionService from './service';

const versionVue = '37.35 Jaygarcia Saturn';

const props = ref({
  apiVersion: {
    version: {
      type: String,
      default: '',
    },
    nickName: {
      type: String,
      default: '',
    },
    etradeVersion: {
      type: String,
      default: '37.35',
    },
    tamanhoBanco: {
      type: Number,
      default: 0,
    },
  },
});

const tamanhoLimiteBanco = 10;

const tamanhoAvisoBanco = 9;

const tamanhoBanco = computed(() => {
  const tamanho = Number(props.value.apiVersion.tamanhoBanco);
  return Number.isFinite(tamanho) && tamanho > 0 ? tamanho : 0;
});

const bancoProximoDoLimite = computed(() => tamanhoBanco.value >= tamanhoAvisoBanco);

const tamanhoBancoLabel = computed(() => `${tamanhoBanco.value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} GB`);

const tamanhoLimiteLabel = `${tamanhoLimiteBanco} GB`;

async function loadVersion() {
  await VersionService.getAbout().then((data) => {
    props.value.apiVersion = data;
  });
}

export { props, versionVue, loadVersion, tamanhoBanco, tamanhoLimiteBanco, bancoProximoDoLimite, tamanhoBancoLabel, tamanhoLimiteLabel };
